export const initialValues = {
  userDocumentInfo: [],
  applicantInformation: {
    fullName: '',
    contactEmail: '',
  },
  application: {
    name: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    homePhone: '',
    workPhone: '',
    otherPhone: '',
    dob: '',
    lastFourSocial: '',
    gender: '',
    maritalStatus: '',
    disabled: '',
    desiredBedrooms: '',
    races: '',
    incomeSources: {
      wages: '',
      pension: '',
      publicAssistance: '',
      ssi: '',
      other: '',
    },
  },
  householdIncome: [],
};
